import { LanguageID } from "configs";
import _capitalize from "lodash/capitalize";
import _get from "lodash/get";
import { i18n } from "translations";

import { loadLocalStorage } from "./storage";

interface AnyObject {
  [key: string]: unknown;
}

export const getErrorMessage = (
  errors: AnyObject,
  fieldName: string
): AnyObject | null => {
  return _get(errors, fieldName, null) as AnyObject;
};

export const checkMainLan = () => {
  const lan = loadLocalStorage("lan");
  if (lan === LanguageID.vi) return true;
  return false;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getLanContent = (row: any, field: string) => {
  const fieldName = checkMainLan() ? `native${_capitalize(field)}` : field;
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return row?.[fieldName || ""] || "";
};

export const getInvalidMessage = (fieldName = ""): string => {
  return (
    i18n.t("invalidField")?.replace("{FIELD}", fieldName?.toLowerCase()) || ""
  );
};

export const getInvalidMessageI18n = (fieldName = ""): string => {
  return i18n.t("invalidField")?.replace("{FIELD}", i18n.t(fieldName)) || "";
};

export const getRequiredI18n = (fieldName = ""): string => {
  return i18n.t("requiredField")?.replace("{FIELD}", i18n.t(fieldName)) || "";
};

export const getValueEmptyInExcel = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  input: any,
  defaultValue?: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): any => {
  if (String(input) === "null" || String(input) === "undefined") {
    return defaultValue || "";
  }
  return input;
};
